<template>
  <vs-row vs-w="12" class="wrap-option" v-bind:class="{ 'selected': selectedCategory }">
    <vs-col vs-lg="8" vs-sm="4" vs-xs="12">
      <div>
        <input
          maxlength="10"
          class="input-option" v-bind:class="{
            'input-blocked': !editMood
          }"
          size="small" v-model="option.valor"
        />
      </div>
      <div>
        <input
          maxlength="100"
          class="input-option" v-bind:class="{
            'input-blocked': !editMood
          }"
          size="small"
          v-model="option.descripcion"
        />
      </div>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
      <vs-button
        v-if="type === 'category'"
        v-tooltip="'Ver documentos'"
        color="primary"
        class="margin-right"
        size="small"
        type="border"
        v-on:click="listDocuments(option)"
        icon="search"
      />
      <CheckPermission permission="ED029" v-if="!editMood">
        <vs-button
          v-tooltip="'Editar Opción'"
          color="primary"
          class="margin-right"
          size="small"
          type="border"
          v-on:click="editOption()"
          icon="edit"
        />
      </CheckPermission>
      <vs-button
        disabled
        v-if="!editMood && canProcess"
        v-tooltip="'Numeración de la opción'"
        color="primary"
        class="margin-right"
        size="small"
        type="border"
        icon="settings_remote"
      />
      <CheckPermission permission="ED030">
        <vs-switch
          v-tooltip="selected ? 'Deshabilitar opción' : 'Habilitar opción'"
          color="primary"
          v-model="selected"
          v-on:click="toggleEnableOption({ option, selected, type })"
        />
      </CheckPermission>
    </vs-col>
    <b-modal
      :title="`Editar opción ${option.descripcion}`"
      @close="clearNumeration"
      hide-footer
      size="lg"
      centered
      ref="modalOption"
    >
      <ManageOption
        :option="option"
        :type="type"
        @save-option="saveOption"
      />
    </b-modal>
  </vs-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import ManageOption from '@/febos/chile/tools/components/ManageOption';

export default {
  components: { CheckPermission, ManageOption },
  mixins: [],
  data() {
    return {
      editMood: false,
      createMood: false,
      selected: this.option.deshabilitado !== 1,
      numerationMood: false,
      optionNumeration: {}
    };
  },
  props: {
    option: {
      type: Object,
      required: true,
      default: () => {}
    },
    type: {
      type: [String, Object],
      required: true,
      default: () => ''
    },
    selectedCategory: {
      type: Boolean,
      required: false,
      default: false
    },
    category: {
      type: Object,
      required: false
    }
  },
  watch: {
    optionNumeration(newVal) {
      this.optionNumeration = newVal;
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'empresa'
    ]),
    canProcess() {
      return this.option.extra.numOf || this.option.extra.numInt;
    }
  },
  methods: {
    ...mapActions('Herramientas', [
      'listDocuments',
      'toggleEnableOption',
      'saveOptions',
      'saveParentOptions',
      'clearSelected',
      'listCategories'
    ]),
    numerationType() {
      this.numerationMood = true;
    },
    clearNumeration() {
      this.optionNumeration = {
        extra: {
          numInt: false,
          numOf: false
        }
      };
    },
    async cancelOption() {
      this.editMood = !this.editMood;
      if (this.type === 'category') {
        await this.listCategories({
          grupoOpcion: 'tipos.documentos-ed',
          deshabilitado: 'si'
        });
      } else {
        await this.listDocuments(this.category);
      }
    },
    editOption() {
      this.$refs.modalOption.show();
      this.createMood = false;
      if (this.type === 'category') {
        this.clearSelected({ type: 'CATEGORY', option: this.option });
      }
    },
    async saveOption() {
      const optionEdit = {
        ...this.option,
        extra: JSON.stringify({
          numOf: this.option.extra.numOf || false,
          numInt: this.option.extra.numInt || false,
          ...this.option.extra
        })
      };
      if (this.type !== 'category') {
        await this.saveOptions(optionEdit);
        await this.listDocuments(this.category);
      } else {
        optionEdit.parametroId = `tipos.documentos-ed.${ this.option.valor}`;
        await this.saveParentOptions(optionEdit);
        await this.listDocuments(optionEdit);
      }
      if (this.$refs.modalOption) {
        this.$refs.modalOption.hide();
      }
    }
  }
};
</script>

<style lang="css" scoped>

.button-add {
  display: flex;
  justify-content: center;
  align-items: center;
}

  .margin-top {
    margin-top: 20px;
  }
  .margin-right {
    margin-right: 10px;
  }

  .wrap-option {
    background:  #f8f8f8;
    margin-bottom: 6px;
  }

  .input-option {
    color: inherit;
    margin-top: 4px;
    width: 80%;
    background: transparent;
  }

  .input-blocked {
    color: inherit;
    pointer-events: none;
    border: none !important;
    padding: 4px 4px 6px 4px;
    border-radius: 5px;
  }

  .input-edit {
    color: inherit;
    border: 1px solid #66258324;
    padding: 4px 4px 6px 4px;
    border-radius: 5px;
  }

  .selected {
    background: #cfe7f3;
  }

  .box-config {
    max-height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
</style>
